import { PropsWithChildren } from "react";
import { useClassList } from "../../hooks/useClassList.js";

interface Props extends React.HTMLAttributes<HTMLElement> {
  className: string;
  position?: "left" | "right" | "top" | "bottom";
  open: boolean;
  onClose: () => void;
}

export const Drawer: React.FC<PropsWithChildren<Props>> = ({
  position = "left",
  open,
  className,
  children,
  ...rest
}) => {
  const classlist = [
    {
      class: "drawer",
      active: true,
    },
    {
      class: "drawer-open",
      active: open,
    },
    {
      class: "drawer-closed",
      active: !open,
    },
    {
      class: "drawer-left",
      active: position === "left",
    },
    {
      class: "drawer-right",
      active: position === "right",
    },
    {
      class: "drawer-top",
      active: position === "top",
    },
  ];

  const classes = useClassList(
    classlist[0],
    classlist[1],
    classlist[2],
    classlist[3],
    classlist[4],
    classlist[5]
  );

  const classesUsed = `${classes.classNames} ${className}`;

  return (
    <nav
      role="dialog"
      className={classesUsed}
      aria-hidden={!open}
      aria-live="polite"
      aria-expanded={open}
      tabIndex={-1}
      {...rest}
    >
      {children}
    </nav>
  );
};
